import styled from 'styled-components';

export const TreeViewContainer = styled.div`
    min-width: 220px;
    min-height: 200px;
    max-width: 400px;
    max-height: 400px;
    border: 1px solid #333;
    overflow-y: auto;
    overflow-x: hidden;
    padding-top: 5px;
    
    &[disabled]{
        pointer-events: none;
        background-color: #d0d7dd;
        filter: grayscale(1) opacity(0.5);
        border: 1px solid #3c5064;
        cursor: not-allowed;
    }
`;
